<img [src]="img" [attr.class]="css" (load)="loading()" (error)="imgError()" [alt]="alt" *ngIf="img, else noImage">
<ng-template #noImage>
    <img [src]="defaultImage" [attr.class]="css" alt="default">
</ng-template>